import { render, staticRenderFns } from "./NotificationViewerDialog.vue?vue&type=template&id=79ae0448&"
import script from "./NotificationViewerDialog.vue?vue&type=script&lang=ts&"
export * from "./NotificationViewerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports